import React from 'react';
import { Sparkles } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const galleryImages = [
  'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=900&q=80',
  'https://images.unsplash.com/photo-1518005020951-eccb494ad742?auto=format&fit=crop&w=900&q=80',
  'https://images.unsplash.com/photo-1578632767115-351597cf2477?auto=format&fit=crop&w=900&q=80',
  'https://images.unsplash.com/photo-1574158622682-e40e69881006?auto=format&fit=crop&w=900&q=80',
  'https://images.unsplash.com/photo-1507608616759-54f48f0af0ee?auto=format&fit=crop&w=900&q=80',
  'https://images.unsplash.com/photo-1542362567-b07e54358753?auto=format&fit=crop&w=900&q=80',
];

const Gallery = () => {
  const { t } = useLanguage();

  return (
    <section id="gallery" className="py-24 bg-[#0b0817] relative overflow-hidden">
      <div className="absolute inset-0 opacity-40 pointer-events-none bg-[radial-gradient(ellipse_at_80%_0%,rgba(34,211,238,0.12),transparent_50%)]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="inline-flex items-center gap-2 text-primary-light text-sm font-bold uppercase tracking-[0.2em]">
            <Sparkles className="w-4 h-4" />
            AI Gallery
          </span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-white font-heading">
            {t.gallery.title}
          </h2>
          <p className="mt-4 text-lg text-slate-400 leading-relaxed">{t.gallery.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.gallery.items.map((item, index) => (
            <article
              key={item.title}
              className="group bg-card-dark border border-border-dark rounded-3xl overflow-hidden hover:border-primary/40 hover:shadow-glow transition-all duration-300"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={galleryImages[index]}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  width={900}
                  height={675}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark/80 via-transparent to-transparent" />
                <div className="absolute left-4 bottom-4 rounded-full bg-dark/80 border border-white/10 px-3 py-1 text-xs font-bold text-primary-light backdrop-blur">
                  {t.gallery.styleLabel}: {item.style}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-extrabold text-white font-heading">{item.title}</h3>
                <p className="mt-3 text-slate-400 leading-relaxed text-sm">{item.prompt}</p>
                <div className="mt-6 flex items-center justify-between border-t border-border-dark pt-4">
                  <div>
                    <p className="text-white font-semibold text-sm">{item.author}</p>
                    <p className="text-slate-500 text-xs">{item.role}</p>
                  </div>
                  <span className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-pink flex items-center justify-center text-white font-bold">
                    {item.author.charAt(0)}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
